<!-- DESKTOP -->
<div
  *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
  id="desktop"
>
  <!-- Product Card Info -->
  <div class="usf-product-card-info">
    <!-- Product Card Thumbnail -->
    <a
      *ngIf="!navigationDisabled"
      class="usf-product-card-img"
      [attr.data-cy]="'product-card-image-' + product?.productNumber + '-link'"
      [routerLink]="productRoute"
      [class.no-route]="this.isExceptionSubCompare"
    >
      <img
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAlternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="(panAppState.online$ | async) === true && !!thumbnailImageURL"
        [attr.data-cy]="'product-card-' + product?.productNumber + '-image'"
      />
      <ion-icon
        name="restaurant"
        *ngIf="(panAppState.online$ | async) === false || !thumbnailImageURL"
        class="no-image"
        data-cy="product-card-no-image-icon"
      ></ion-icon>
    </a>

    <span
      *ngIf="navigationDisabled"
      class="usf-product-card-img"
      [attr.data-cy]="'product-card-image-' + product?.productNumber + '-link'"
      [class.no-route]="this.isExceptionSubCompare"
    >
      <img
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAlternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="(panAppState.online$ | async) === true && !!thumbnailImageURL"
        [attr.data-cy]="'product-card-' + product?.productNumber + '-image'"
      />
      <ion-icon
        name="restaurant"
        *ngIf="(panAppState.online$ | async) === false || !thumbnailImageURL"
        class="no-image"
        data-cy="product-card-no-image-icon"
      ></ion-icon>
    </span>

    <!-- Product Card Brand, Description, Number, Sales Pack Price, Note -->
    <div class="usf-product-card-desc">
      <div
        class="usf-product-card-brand-txt"
        [attr.data-cy]="'product-brand-' + product?.productNumber + '-text'"
      >
        {{ product?.summary?.brand || ' ' | acronymTitleCase }}
      </div>
      <a
        *ngIf="!navigationDisabled"
        class="usf-product-card-desc-heading-txt"
        data-cy="product-description-text-link"
        [routerLink]="productRoute"
        [class.no-route]="this.isExceptionSubCompare"
      >
        {{ (product?.summary?.productDescTxtl | acronymTitleCase) || ' ' }}
      </a>

      <span
        *ngIf="navigationDisabled"
        class="usf-product-card-desc-heading-txt"
        data-cy="product-description-text-link"
        [class.no-route]="this.isExceptionSubCompare"
      >
        {{ (product?.summary?.productDescTxtl | acronymTitleCase) || ' ' }}
      </span>
    </div>
  </div>

  <div
    class="usf-product-card-desc-body-txt"
    [attr.data-cy]="
      'product-card-desc-body-' + product?.productNumber + '-text'
    "
  >
    <span>#{{ product?.productNumber || ' ' }}</span
    ><span class="break">|</span
    ><span>{{ product?.summary?.salesPackSize }}</span>
    <br />
    <span *ngIf="!pricingDisabled && product?.pricing?.unitPrice * 1 > 0">
      {{ (product?.pricing?.unitPrice | currency) || 'loading..' }}
      {{ product?.summary?.priceUom || 'CS' }}
    </span>
    <span *ngIf="pricingDisabled || product?.pricing?.unitPrice * 1 === 0">
      {{ 'i18n.lists.noPrice' | translate }}
    </span>
    <span *ngIf="product?.summary?.breakable">
      <span *ngIf="!pricingDisabled && product?.pricing?.eachPrice * 1 > 0">
        {{ (product?.pricing?.eachPrice | currency) || 'loading..' }}
        {{
          (product?.summary?.catchWeightFlag
            ? '/' + product?.summary?.priceUom
            : product?.summary?.eachUom) || 'EA'
        }}
      </span>
      <span *ngIf="pricingDisabled || product?.pricing?.eachPrice * 1 === 0">
        {{ 'i18n.lists.noPrice' | translate }}
      </span>
    </span>
  </div>
  <div class="usf-product-card-price">
    <div class="usf-product-card-case">
      <app-quantity-input
        [productNumber]="product?.productNumber"
        [quantity]="quantityUnit"
        (quantityUpdateEmitter)="updateQuantity($event)"
        [isDisabled]="
          quantityInputsDisabled ||
          product?.summary?.properties?.has(propertiesEnum.specialOrder)
        "
        [isOffline]="false === (panAppState.online$ | async)"
        [isEaches]="false"
        [platform]="platformEnum"
        [isProductCard]="true"
      >
      </app-quantity-input>
      <div
        *ngIf="!product?.summary?.properties?.has(propertiesEnum.specialOrder)"
        [attr.data-cy]="
          'product-price-with-cases-' + product?.productNumber + '-text'
        "
      >
        <span *ngIf="!pricingDisabled && product?.pricing?.unitPrice * 1 > 0">
          {{ (product?.pricing?.unitPrice | currency) || 'loading..' }}
          {{ product?.summary?.priceUom || 'CS' }}
        </span>
        <span *ngIf="pricingDisabled || product?.pricing?.unitPrice * 1 === 0">
          {{ 'i18n.lists.noPrice' | translate }}
        </span>
      </div>
    </div>
    <div class="usf-product-card-each" *ngIf="product?.summary?.breakable">
      <app-quantity-input
        [productNumber]="product?.productNumber"
        [quantity]="quantityEach"
        (quantityUpdateEmitter)="updateQuantity($event)"
        [isDisabled]="quantityInputsDisabled ? true : false"
        [isOffline]="false === (panAppState.online$ | async)"
        [isEaches]="true"
        [platform]="platformEnum"
        [isProductCard]="true"
      >
      </app-quantity-input>
      <div
        *ngIf="!product?.summary?.properties?.has(propertiesEnum.specialOrder)"
        [attr.data-cy]="
          'product-price-with-eaches-' + product?.productNumber + '-text'
        "
      >
        <span *ngIf="!pricingDisabled && product?.pricing?.eachPrice * 1 > 0">
          {{ (product?.pricing?.eachPrice | currency) || 'loading..' }}
          {{
            (product?.summary?.catchWeightFlag
              ? '/' + product?.summary?.priceUom
              : product?.summary?.eachUom) || 'EA'
          }}
        </span>
        <span *ngIf="pricingDisabled || product?.pricing?.eachPrice * 1 === 0">
          {{ 'i18n.lists.noPrice' | translate }}
        </span>
      </div>
    </div>
  </div>
</div>

<!-- TOUCH -->
<div
  *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
  id="touch"
>
  <!-- Product Card Info -->
  <div class="usf-product-card-info">
    <!-- Product Card Thumbnail -->
    <a
      *ngIf="!navigationDisabled"
      class="usf-product-card-img"
      [attr.data-cy]="'product-card-image-' + product?.productNumber + '-link'"
      [routerLink]="productRoute"
      [class.no-route]="this.isExceptionSubCompare"
    >
      <img
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAlternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="(panAppState.online$ | async) === true && !!thumbnailImageURL"
        [attr.data-cy]="'product-card-' + product?.productNumber + '-image'"
      />
      <ion-icon
        name="restaurant"
        *ngIf="(panAppState.online$ | async) === false || !thumbnailImageURL"
        class="no-image"
        data-cy="product-card-no-image-icon"
      ></ion-icon>
    </a>

    <span
      *ngIf="navigationDisabled"
      class="usf-product-card-img"
      [attr.data-cy]="'product-card-image-' + product?.productNumber + '-link'"
      [class.no-route]="this.isExceptionSubCompare"
    >
      <img
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAlternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="(panAppState.online$ | async) === true && !!thumbnailImageURL"
        [attr.data-cy]="'product-card-' + product?.productNumber + '-image'"
      />
      <ion-icon
        *ngIf="(panAppState.online$ | async) === false || !thumbnailImageURL"
        class="no-image"
        name="restaurant"
        data-cy="product-card-no-image-icon"
      ></ion-icon>
    </span>

    <!-- Product Card Brand, Description, Number, Sales Pack Price, Note -->
    <div class="usf-product-card-desc">
      <div
        class="usf-product-card-brand-txt"
        [attr.data-cy]="'product-brand-' + product?.productNumber + '-text'"
      >
        {{ product?.summary?.brand || ' ' | acronymTitleCase }}
      </div>
      <a
        *ngIf="!navigationDisabled"
        class="usf-product-card-desc-heading-txt"
        data-cy="product-description-text-link"
        [routerLink]="productRoute"
        [class.no-route]="this.isExceptionSubCompare"
      >
        {{ (product?.summary?.productDescTxtl | acronymTitleCase) || ' ' }}
      </a>

      <span
        *ngIf="navigationDisabled"
        class="usf-product-card-desc-heading-txt"
        data-cy="product-description-text-link"
        [class.no-route]="this.isExceptionSubCompare"
      >
        {{ (product?.summary?.productDescTxtl | acronymTitleCase) || ' ' }}
      </span>
    </div>
  </div>

  <div
    class="usf-product-card-desc-body-txt"
    [attr.data-cy]="
      'product-card-desc-body-' + product?.productNumber + '-text'
    "
  >
    <span>#{{ product?.productNumber || ' ' }}</span
    ><span>|</span><span>{{ product?.summary?.salesPackSize }}</span>
    <span>|</span>
    <span *ngIf="!pricingDisabled && product?.pricing?.unitPrice * 1 > 0">
      {{ (product?.pricing?.unitPrice | currency) || 'loading..' }}
      {{ product?.summary?.priceUom || 'CS' }}
    </span>
    <span *ngIf="pricingDisabled || product?.pricing?.unitPrice * 1 === 0">
      {{ 'i18n.lists.noPrice' | translate }}
    </span>
    <div *ngIf="product?.summary?.breakable">
      /
      <span *ngIf="!pricingDisabled && product?.pricing?.eachPrice * 1 > 0">
        {{ (product?.pricing?.eachPrice | currency) || 'loading..' }}
        {{
          (product?.summary?.catchWeightFlag
            ? '/' + product?.summary?.priceUom
            : product?.summary?.eachUom) || 'EA'
        }}
      </span>
      <span *ngIf="pricingDisabled || product?.pricing?.eachPrice * 1 === 0">
        {{ 'i18n.lists.noPrice' | translate }}
      </span>
    </div>
  </div>
  <div class="usf-product-card-price">
    <div class="usf-product-card-case">
      <app-quantity-input
        [productNumber]="product?.productNumber"
        [quantity]="quantityUnit"
        [isDisabled]="
          quantityInputsDisabled ||
          product?.summary?.properties?.has(propertiesEnum.specialOrder)
        "
        [isOffline]="false === (panAppState.online$ | async)"
        [isEaches]="false"
        [platform]="platformEnum"
        (quantityUpdateEmitter)="updateQuantity($event)"
      >
      </app-quantity-input>
      <div
        *ngIf="!product?.summary?.properties?.has(propertiesEnum.specialOrder)"
        [attr.data-cy]="
          'product-price-with-cases-' + product?.productNumber + '-text'
        "
      >
        <span *ngIf="!pricingDisabled && product?.pricing?.unitPrice * 1 > 0">
          {{ (product?.pricing?.unitPrice | currency) || 'loading..' }}
          {{ product?.summary?.priceUom || 'CS' }}
        </span>
        <span *ngIf="pricingDisabled || product?.pricing?.unitPrice * 1 === 0">
          {{ 'i18n.lists.noPrice' | translate }}
        </span>
      </div>
    </div>
    <div class="usf-product-card-each" *ngIf="product?.summary?.breakable">
      <app-quantity-input
        [productNumber]="product?.productNumber"
        [quantity]="quantityEach"
        [isDisabled]="quantityInputsDisabled ? true : false"
        [isOffline]="false === (panAppState.online$ | async)"
        [isEaches]="true"
        [platform]="platformEnum"
        (quantityUpdateEmitter)="updateQuantity($event)"
      >
      </app-quantity-input>
      <div
        *ngIf="!product?.summary?.properties?.has(propertiesEnum.specialOrder)"
        [attr.data-cy]="
          'product-price-with-eaches-' + product?.productNumber + '-text'
        "
      >
        <span *ngIf="!pricingDisabled && product?.pricing?.eachPrice * 1 > 0">
          {{ (product?.pricing?.eachPrice | currency) || 'loading..' }}
          {{
            (product?.summary?.catchWeightFlag
              ? '/' + product?.summary?.priceUom
              : product?.summary?.eachUom) || 'EA'
          }}
        </span>
        <span *ngIf="pricingDisabled || product?.pricing?.eachPrice * 1 === 0">
          {{ 'i18n.lists.noPrice' | translate }}
        </span>
      </div>
    </div>
  </div>
</div>
